jQuery(window).on('elementor/frontend/init', (e) => {
  elementorFrontend.hooks.addAction(
    'frontend/element_ready/onereach-accordion-slider.default',
    ($element) => {
      const tabsWrapper = $element.find('.onereach-accordion-slider').get(0);
      const titles = tabsWrapper.querySelectorAll('.onereach-accordion-slider__item-title');
      const medias = tabsWrapper.querySelectorAll('.onereach-accordion-slider__media-item');
      titles.forEach(function (title) {
        title.addEventListener('click', function () {
          const elIndex = this.getAttribute('data-item');
          const content = this.nextElementSibling;
          titles.forEach(function (title) {
            title.nextElementSibling.classList.remove("active");
            title.nextElementSibling.style.maxHeight = null;
          });
          medias.forEach(function (media) {
            media.classList.remove("active");
            if(media.getAttribute('data-item') === elIndex) {
              media.classList.add("active");
              if(media.querySelector('video')) {
                media.querySelector('video').play();
              }
            }
          });
          content.classList.add("active");
          content.style.maxHeight = content.scrollHeight + "px";
        });
      });

      titles[0].click();
    }
  )
});